import JsPDF from 'jspdf';
import Button from 'react-bootstrap/Button';
import html2canvas from 'html2canvas';

const FromularioPdf = () => {
  const createPDF = () => {
    html2canvas(document.querySelector('#formularioFolio')).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const imgWidth = 210;
      const pageHeight = 295;
      const imgHeight = canvas.height * (imgWidth / canvas.width);
      let heightLeft = imgHeight;

      const doc = new JsPDF('p', 'mm');
      let position = 0;

      doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        doc.addPage();
        doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      doc.save(`TEscucha_${new Date().getTime()}.pdf`);
    });
  };

  return (
    <span>
      <Button variant="outline-danger" onClick={createPDF}>
        pdf
      </Button>
    </span>
  );
};

export default FromularioPdf;
